import { createApp , ref } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from './contextStore.js'

var windows_store = [];

export function registerWindow( el , classActive , classInactive ){

    if( !windows_store.find( win => win.element === el ) ){
        windows_store.push(
            {
                element : el ,
                active : classActive ,
                inactive : classInactive
            }
        );
    }
}

export function openWindow( item ){
    windows_store.forEach(
        win => {
            if( win.element === item ){
                win.element.classList.remove( win.inactive );
                win.element.classList.add( win.active );
            }else{
                win.element.classList.remove( win.active );
                win.element.classList.add( win.inactive );
            }
        }
    )
}

document.addEventListener(
    'click' ,
    ( e ) => {

        let clicked = document.elementsFromPoint( e.pageX , e.pageY );
        let temp = e.target;

        while( temp ){
            clicked.push( temp );
            temp = temp.parentElement
        }

        let finded = windows_store.find(
            win => {

                for( let item of clicked ){
                    if( win.element === item ){
                        return true;
                    }
                }

            }
        );

        openWindow( finded?.element );
    }
)


function initAuthReactive(){

    const el = document.querySelector( '#auth-block' );
    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();

                    const delay = ref( 0 );
                    const phone = ref( '' );
                    const phone_error = ref( '' );
                    const code = ref( '' );
                    const code_error = ref( '' );
                    const name = ref( '' );
                    const name_error = ref( '' );

                    const show_code = ref( false );
                    const show_register = ref( false );
                    const show_auth = ref( false );

                    function clearPhone(){
                        return phone.value = phone.value.replace( /[^0-9]/gi , '' ).trim();
                    }

                    function clearName(){
                        return name.value = name.value.replace( /[^a-zA-Zа-яёА-ЯЁ\s]/gi , '' ).trim();
                    }

                    function clearCode(){
                        return code.value = phone.value.replace( /[^0-9]/gi , '' ).trim();
                    }

                    function prettyPhone(){
                        if( !checkPhone() ){
                            return;
                        }
                        let matches = clearPhone().match( /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/i )
                        return `+${ matches[ 1 ] } ( ${ matches[ 2 ] } ) ${ matches[ 3 ] }-${ matches[ 4 ] }-${ matches[ 5 ] }`;
                    }

                    function checkPhone(){
                        return /^79[0-9]{9}/.test( clearPhone() );
                    }

                    function checkName(){
                        return /^[a-zA-Zа-яёА-ЯЁ\s]+$/.test( clearName() );
                    }

                    function checkCode(){
                        return /^79[0-9]{6}/.test( clearPhone() );
                    }

                    async function confirmAuth(){

                        if(
                            delay.value > 0
                            || !checkPhone()
                        ){
                            return;
                        }

                        show_code.value = false;
                        show_register.value = false;
                        show_auth.value = false;

                        delay.value = 60;
                        let interval_id = setInterval(
                            () => {
                                delay.value--;
                                if( delay.value <= 0 ){
                                    clearInterval( interval_id )
                                }
                            } ,
                            1000
                        );

                        try{
                            let response = await contextStore.confirmAuth( clearPhone() );

                            if( response.hasOwnProperty( 'register' ) ){
                                show_register.value = response.register;
                                show_auth.value = !show_register.value;
                                show_code.value = true;
                            }

                        }catch( e ){
                            console.log( e.message )
                        }

                    }

                    async function loginAuth(){

                        if(
                            !checkPhone()
                            || ( show_register.value && !checkName() )
                            || !checkCode()
                        ){
                            return;
                        }

                        try{
                            let response = await contextStore.sendAuth( phone.value , code.value , name.value );
                        }catch( e ){
                            console.log( e.message )
                        }

                    }

                    return {
                        contextStore ,
                        delay ,
                        checkPhone ,
                        prettyPhone ,
                        confirmAuth ,
                        loginAuth ,

                        show_code ,
                        show_register ,
                        show_auth ,

                        phone ,
                        phone_error ,
                        code ,
                        code_error ,
                        name ,
                        name_error

                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initAuthReactive );

